export default {"src":"/_next/static/media/TEALENGTH.eb63a09b.svg","height":150,"width":63,"blurWidth":0,"blurHeight":0};